<style lang="stylus">
    .ShareBox-mask
        modal-mask()
        .ShareBox-modal
            width 460px
            position relative
            .dialog-slot
                overflow-y unset
            .ShareBox-title
                display flex
                align-items center
                height 100%
                .ShareList
                    margin 0px 15px 0px 5px
                    font-size: 14px;
                    line-height: 16px;
                    color: #000000;
                    cursor: pointer;
                .active-share
                    font-weight: bold;
            .ShareBox-body
                padding 20px
                padding-bottom 12px
                .ShareBox-link
                    display flex
                    align-items center
                    .link-box
                        border: 1px solid #DCDEE1;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        flex: 1;
                        height: 32px;

                        input
                            outline: none !important;
                            border: 0;
                            flex: 1;
                            padding-left 22px
                        .refresh-icon
                            padding: 4px;
                            display: flex;
                            align-items: center;
                            margin-right 4px
                            margin-left 8px
                            svg
                                cursor: pointer;
                                width: 16px;
                                height: 16px;
                                outline: none;
                            &:active
                                background: #ECECEC;
                                border-radius: 2px;
                .link-btn
                    margin-left: 6px;
                    width: 100px;
                    span
                        display block
                        width 100%
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                .ShareBox-password
                    display flex
                    align-items center
                    justify-content space-between
                    margin-top 22px
                    height: 24px;
                    .right
                        display flex
                        align-items center
                    .tips
                        display flex
                        align-items center
                        span
                            font-size: 12px;
                            line-height: 16px;
                            color: #000000;
                        img
                            width 12px
                            height 12px
                            margin-left 4px
                            cursor pointer
                    .password-box
                        border: 1px solid #DCDEE1;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        height: 24px;
                        margin-right 8px
                        span
                            font-size: 10px;
                            line-height: 12px;
                            padding-right 12px
                            color: #017FFF;
                            text-decoration: underline;
                            cursor: pointer;
                        input
                            outline: none !important;
                            border: 0;
                            padding-left 12px
                            width: 70px;
                .ShareBox-date
                    display flex
                    align-items center
                    justify-content space-between
                    margin-top 16px
                    padding-bottom 22px
                    border-bottom 1px solid #E0E0E0
                    .tips
                        font-size: 12px;
                        line-height: 16px;
                        color: #000000;
                    .dropdown-expire
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        position relative
                        z-index 1

                        .ivu-icon-ios-arrow-down
                            transition: .3s transform;
                            &.active
                                transform: rotate(180deg);
                    .expire-list
                        background: #FFFFFF;
                        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1), 0px 8px 16px rgba(0, 0, 0, 0.0982299);
                        border-radius: 2px;
                        padding: 6px 0;
                        position: absolute;
                        right 0
                        top: calc(100% + 7px);
                        .expire-item
                            white-space: nowrap;
                            padding: 6px 16px 6px 36px;
                            position relative
                            .text
                                font-size: 12px;
                                line-height: 16px;
                                color: #000000;
                            &:hover
                                background: #F3F3F3;
                            &.active
                                .text
                                    color: #017FFF;
                                &:before
                                    line-height: 0;
                                    content: url("data:image/svg+xml,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20width%3D'16'%20height%3D'16'%20%3E%3Cpath%20stroke%3D'%23017FFF'%20stroke-width%3D'2'%20fill%3D'none'%20stroke-linecap%3D'round'%20stroke-linejoin%3D'round'%20d%3D'M4%208l2.5%202.5L12%205'%2F%3E%3C%2Fsvg%3E");
                                    position: absolute;
                                    display: block;
                                    left: 12px;
                                    top: 8px;
                                    width: 16px;
                                    height: 16px;

                .ShareBox-qrcode
                    display flex
                    align-items center
                    justify-content space-between
                    padding 22px 0
                    border-bottom 1px solid #E0E0E0
                    img
                        margin-left 18px
                .ShareBox-member
                    .title
                        padding: 22px 0px 16px 0;
                    .member-list
                        padding: 0px 16px;
                        min-height: 32px;
                        max-height: 182px;
                        overflow: auto;
                        border-bottom 1px solid #E0E0E0
                        .member-item
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom 16px
                            .member-avatar
                                display: flex;
                                align-items: center;
                                img
                                    width: 28px;
                                    height: 28px;
                                    margin-right 8px
                                    border-radius: 50%;
                                .no-icon
                                    text-align: center;
                                    color: #7a5923;
                                    font-size: 13px;
                                    width: 28px;
                                    height: 28px;
                                    line-height: 28px;
                                    margin-right 8px
                                    background: #fff8e5;
                                    border-radius: 50%;
                                span
                                    font-size: 12px;
                                    line-height: 16px;
                                    color: #666666;
                .ShareBox-shareLink
                    margin-top: 20px
                    display: flex;
                    justify-content: space-between;
                    .ShareBox-left
                        .icon-wrapper
                            margin-top: 20px
                            display: flex;
                            flex-shrink 0
                            .ShareBox-icon
                                display: flex;
                                margin-right: 18px;
                                width: 24px;
                                height: 24px;
                                cursor: pointer;
                                transition: transform .2s linear;
                                position relative
                                .item-icon
                                    width: 24px;
                                    height: 24px;
                                    &:hover
                                        transform: scale(1.1);
                                .item-icon-code
                                    position absolute
                                    left calc(100% + 10px)
                                    transform: translateY(-50%);
                                    top: 50%;
                                    z-index: 1;
                    .ShareBox-right
                        padding: 8px
                        border: 1px solid rgba(0, 0, 0, 0.06);
                        border-radius: 4px;
                        text-align: center;
                        color: rgba(0, 0, 0, 0.6)
                        font-size: 10px;
                        line-height: 16px;
                        >img
                            height 98px
                        >p{
                            margin-top: 10px
                        }
                .preview-img
                    border: 1px solid #DCDEE1;
                    border-radius: 4px;
                    width: 420px;
                    height: 190px;
                    overflow: hidden;
                .html-box
                    .title
                        padding 22px 0px 16px 0px
                        font-size: 12px;
                        line-height: 16px;
                        color: #000000;
                    .html-content
                        border: 1px solid #DCDEE1;
                        border-radius: 4px;
                        width: 420px;
                        overflow: auto;
                        padding: 16px;
                        outline: none;
                        height: 125px;
                        resize: none;
                    .share-btn-wrap
                        text-align: right;
                        padding-top 25px
                        padding-bottom 15px
                        .html-btn
                            min-width: 100px;
                            max-width 100%
                            span
                                display block
                                width 100%
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                .invite-user
                    .title
                        font-weight: bold;
                        font-size: 12px;
                    .invite-link
                        display: flex;
                        align-items: center;
                        margin-top: 16px;
                        .link-box
                            border: 1px solid #DCDEE1;
                            box-sizing: border-box;
                            border-radius: 4px;
                            flex: 1;
                            height: 32px;
                            display: flex;
                            align-items: center;
                            input
                                flex: 1;
                                outline: none !important;
                                border: 0px;
                                padding: 0px 15px;


                        .link-btn
                            margin-left: 6px;
                            width: 100px;
                            span
                                display block
                                width 100%
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap



                .invite-type
                    padding: 26px 0px 22px 0px;
                    border-bottom: 1px solid #E0E0E0;
                    .title
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        span
                            font-weight: bold;
                            font-size: 12px;
                    .type
                        display: flex;
                        margin-top 16px;
                        .link-btn
                            margin-left 6px
                            width: 100px;
                            span
                                display block
                                width 100%
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                        .ivu-select
                            flex: 1;
                .item-dropbox
                    position relative
                    padding-left 10px
                    cursor: pointer;
                    padding-right 8px
                    >span
                        margin-right: 4px;
                        max-width 100px
                        float left
                        display block
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    .item-downs
                        z-index 1
                        position absolute
                        top calc(100% + 10px)
                        left 0
                        padding 6px 0
                        background: #FFFFFF;
                        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1), 0px 8px 16px rgba(0, 0, 0, 0.0982299);
                        border-radius: 2px;
                        .item-down
                            line-height: 28px;
                            height: 28px;
                            font-size: 12px;
                            padding: 0px 16px;
                            cursor: pointer;
                            width 100%
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            &.active
                                color: #017fff;
                            &:hover
                                background: #F3F3F3;
    .notShowCancle
        .dialog-btnbox-normal
                .dialog-btn-ok + div
                    display: none;
    .disable
        opacity: 0.4;
        filter: grayscale(1);
        cursor: not-allowed;
        pointer-events: none
</style>

<template>
    <div class="ShareBox-mask" :class="{ noMask: isPC }">
        <Dialog class="ShareBox-modal" :title="$t('title')" :isShow="true" :useDrag="false" ref="dialog" @close="closeModal">
            <div slot="title" class="ShareBox-title">
                <div class="ShareList" @click="setActive('link')" :class="{ 'active-share': activeShare === 'link' }">
                    {{ $t("shareLink") }}
                </div>
                <div class="ShareList" v-if="false" @click="setActive('html')" :class="{ 'active-share': activeShare === 'html' }">
                    {{ $t("shareHTML") }}
                </div>
            </div>
            <div class="ShareBox-body">
                <div v-if="activeShare === 'link'">
                    <template v-if="internal">
                        <div class="ShareBox-link">
                            <div class="link-box">
                                <div
                                    class="item-dropbox"
                                    :class="{ disable: isShareEdit || isPreviewView || isWorkwx }"
                                    v-click-outside="closeType"
                                    @click.stop="toggleType('type1')"
                                >
                                    <span v-text="getPreviewLimit(shareTypeMap.get(shareType))"></span>
                                    <Icon class="ios-arrow" type="ios-arrow-down" />
                                    <div class="item-downs" v-show="showType === 'type1'">
                                        <div
                                            class="item-down"
                                            v-for="[key, value] in shareTypeMap"
                                            :key="key"
                                            :title="value"
                                            @click.stop="
                                                shareType = key;
                                                setShareType();
                                            "
                                        >
                                            {{ value }}
                                        </div>
                                    </div>
                                </div>
                                <input class="link" type="text" readonly v-model="shareLink" />
                                <div class="refresh-icon">
                                    <iconSymbol
                                        :class="{ disable: isShareEdit }"
                                        :content="$t('refreshLink')"
                                        v-tippy="{ placement: 'top' }"
                                        name="refresh"
                                        @click.native="clickEventType('refreshLinkPrev')"
                                    />
                                </div>
                            </div>
                            <Button class="link-btn" type="primary" @click="copyLink()" :content="$t('copyLink')" v-tippy="{ placement: 'top' }">
                                {{ $t("copyLink") }}
                            </Button>
                        </div>
                        <div class="ShareBox-password">
                            <div class="tips">
                                <span>{{ $t("passCode") }}</span>
                                <VipIcon v-if="!vip" @click.native="showFrame(hasPass, expireType)" />
                            </div>
                            <div class="right">
                                <div class="password-box" v-if="hasPass">
                                    <input :value="shareLinkCode" readonly />
                                    <span :class="{ disable: isShareEdit }" @click="!clickLoading && !isShareEdit && clickEventType('resetPassword')">
                                        {{ $t("changeCode") }}
                                    </span>
                                </div>
                                <i-switch
                                    :disabled="isShareEdit"
                                    v-model="hasPass"
                                    @click.native="switchPrivate"
                                    :loading="isLoadingSw"
                                    size="small"
                                />
                            </div>
                        </div>
                        <div class="ShareBox-date">
                            <span class="tips">{{ $t("setExpire") }}</span>
                            <div class="dropdown-expire" v-click-outside="closeType" :class="{ disable: isShareEdit }">
                                <div @click.stop="toggleType('type2')">
                                    <span style="margin-right: 4px">{{ activeDateString() }}</span>
                                    <i class="ivu-icon ivu-icon-ios-arrow-down" :class="{ active: showType == 'type2' }"></i>
                                </div>
                                <div v-show="showType == 'type2'" class="expire-list" @click.stop>
                                    <template v-for="[key, value] in expireMap">
                                        <div
                                            @click="closeExpireList(key)"
                                            class="expire-item"
                                            :class="{ active: key === expireType }"
                                            :key="key"
                                            v-if="key !== 4"
                                        >
                                            {{ value }}
                                            <VipIcon v-if="!vip && ![5, 6].includes(key)" />
                                        </div>
                                        <DatePicker
                                            ref="datePicker"
                                            :options="dateOptions"
                                            v-else
                                            :open="openDatePicker"
                                            v-model="expireDate"
                                            type="date"
                                            placement="left-start"
                                            @on-change="closeExpireList(key)"
                                            @on-open-change="checkExpireListPop"
                                            :transfer="true"
                                            :key="key"
                                        >
                                            <div
                                                class="expire-item"
                                                :class="{ active: key === expireType }"
                                                @mouseenter.stop="openDatePicker = true"
                                                @mouseleave="checkLeaveTarget"
                                            >
                                                {{ value }}
                                                <VipIcon v-if="!vip" />
                                            </div>
                                        </DatePicker>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="invite-user">
                            <div class="title">{{ $t("inviteUser") }}</div>
                            <div class="invite-link">
                                <div class="link-box" :class="{ disable: isShareEdit }">
                                    <input :placeholder="$t('email')" :readonly="isShareEdit" v-model="email" type="text" />
                                    <div
                                        class="item-dropbox"
                                        :class="{ disable: isShareEdit || isPreviewView }"
                                        v-click-outside="closeType"
                                        @click.stop="toggleType('type3')"
                                    >
                                        <span>{{ inviteTypeStr }}</span>
                                        <Icon class="ios-arrow" type="ios-arrow-down" />
                                        <div class="item-downs" v-show="showType === 'type3'">
                                            <div
                                                class="item-down"
                                                v-for="[key, value] in shareTypeMap"
                                                :key="key"
                                                :value="key"
                                                @click.stop="
                                                    inviteType = key;
                                                    closeType();
                                                "
                                            >
                                                {{ value }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Button
                                    class="link-btn"
                                    type="primary"
                                    :class="{ disable: !emailTest || isShareEdit }"
                                    @click="emailTest && !isShareEdit && clickEventType('inviteMember')"
                                    :content="$t('sendInvite')"
                                    v-tippy="{ placement: 'top' }"
                                >
                                    {{ $t("sendInvite") }}
                                </Button>
                            </div>
                        </div>
                        <div class="invite-type">
                            <div class="title">
                                <span>{{ $t("inviteLink") }}</span>
                                <i-switch
                                    :disabled="isShareEdit"
                                    v-model="shareUseable"
                                    :true-value="1"
                                    :false-value="0"
                                    @on-change="clickEventType('setShareUsable')"
                                    size="small"
                                />
                            </div>
                            <div class="type">
                                <Input v-if="isShareEdit || isPreviewView || !shareUseable" type="text" readonly :value="shareTypeString" />
                                <i-select v-else v-model="shareType" @on-change="setShareType" style="width: 200px">
                                    <i-option v-for="[key, value] in shareLinkTypeMap" :key="key" :value="key">{{ value }}</i-option>
                                </i-select>
                                <Button
                                    class="link-btn"
                                    type="primary"
                                    :class="{ disable: !shareUseable }"
                                    @click="shareUseable && copyLink()"
                                    :content="$t('copyLink')"
                                    v-tippy="{ placement: 'top' }"
                                >
                                    {{ $t("copyLink") }}
                                </Button>
                            </div>
                        </div>
                    </template>
                    <div class="ShareBox-member" v-if="!isWorkwx">
                        <div class="title">
                            {{ $t("joinMembers") }}
                        </div>
                        <div class="member-list">
                            <div class="member-item" v-for="(item, index) in shareMembers" :key="item.uuid">
                                <div class="member-avatar">
                                    <img :src="item.avatar_url" v-if="item.avatar_url" alt="" />
                                    <div class="no-icon" v-else>
                                        {{ getFirstName(item.nick_name || item.email) }}
                                    </div>
                                    <span>{{ item.nick_name || item.email }}</span>
                                </div>
                                <div
                                    class="item-dropbox"
                                    :class="{ disable: isShareEdit || isPreviewView }"
                                    @click.stop="toggleMemberType($event, index)"
                                    v-click-outside="() => (memberShowType = -1)"
                                >
                                    <span v-text="item.option != 2 ? getPreviewLimit(shareTypeMap.get(item.option)) : $t('owner')"></span>
                                    <Icon class="ios-arrow" type="ios-arrow-down" v-if="item.option !== 2" />
                                    <div class="item-downs" v-if="item.option !== 2" :style="memberTypeStyle" v-show="memberShowType == index">
                                        <div
                                            class="item-down"
                                            @click="changeMemberStype(item, key)"
                                            v-for="[key, value] in shareTypeMap"
                                            :key="key"
                                            :title="value"
                                            @click.stop="item.option = key"
                                        >
                                            {{ value }}
                                        </div>
                                        <div class="item-down" @click="removeMember(item, index)">
                                            {{ $t("remove") }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ShareBox-shareLink">
                        <div class="ShareBox-left">
                            <p>{{ $t("shareType") }}</p>
                            <div class="icon-wrapper">
                                <div class="ShareBox-icon" v-for="item in iconList" :key="item.id">
                                    <template v-if="item.name === 'twitter'">
                                        <img class="item-icon" @click.stop="clickIcon(item.id)" src="@/public/img/xlogo.svg" />
                                    </template>
                                    <template v-else>
                                        <iconSymbol @click.native.stop="clickIcon(item.id)" class="item-icon" :name="item.name"></iconSymbol>
                                    </template>
                                    <div
                                        v-click-outside="closeType"
                                        v-show="showType === 'type4'"
                                        class="item-icon-code"
                                        v-if="item.name == 'wechat' || item.name == 'line'"
                                    >
                                        <img :src="QRCodeData" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ShareBox-right">
                            <img :src="QRCodeData" alt="" />
                            <p>{{ $t("scanCode") }}</p>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <img :src="previewUrl" class="preview-img" alt="" />
                    <div class="html-box">
                        <div class="title">
                            {{ $t("useHTML") }}
                        </div>
                        <textarea class="html-content" v-model="shareHTML" readonly />
                        <div class="share-btn-wrap">
                            <Button
                                class="html-btn"
                                type="primary"
                                @click="copyText('html')"
                                :content="$t('copyLink')"
                                v-tippy="{ placement: 'top' }"
                            >
                                {{ $t("copyLink") }}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject, Watch } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    import { addJs } from "@/public/utils/tool";
    import axios from "axios";
    import appConfig from "@/public/globalConfig";
    import type VueComponent from "vue";
    declare var qrcode: any;
    declare var egSize: any;

    @Component({
        components: {
            Dialog,
        },
    })
    export default class ShareBox extends Vue {
        @Inject()
        ["showMessage"];

        QRCodeData: string = "";
        activeShare: string = "link";
        shareTimer = null;
        shareCancel = null;
        isLoadingSw: boolean = false;
        hasPass = !!this.$store.state.shareLinkCode;
        showType = "";

        buildLang = appConfig.language;
        toggleType(type) {
            this.showType = this.showType === type ? "" : type;
        }

        preventMenuClose = false;
        closeType() {
            if (this.preventMenuClose) return;
            this.showType = "";
        }

        memberTypeStyle = {};
        memberShowType = -1;
        toggleMemberType(e, index) {
            const pos = e.currentTarget.getBoundingClientRect();
            this.memberTypeStyle = {
                position: "fixed",
                left: pos.left + "px",
                top: pos.top + pos.height + 10 + "px",
                width: "100px",
            };
            this.memberShowType = index === this.memberShowType ? -1 : index;
        }
        get shareType() {
            return this.$store.state.shareType;
        }
        set shareType(v) {
            this.$store.commit("setState", {
                type: "shareType",
                data: v,
            });
        }
        get inviteTypeStr() {
            return this.getPreviewLimit(this.shareTypeMap.get(this.inviteType));
        }
        get shareTypeMap() {
            if (this.isWorkwx) {
                return new Map([[0, this.$t("view")]]);
            }
            return new Map([
                [0, this.$t("view")],
                [1, this.$t("edit")],
            ]);
        }
        get shareLinkTypeMap() {
            return new Map([
                [0, this.$t("viewLink")],
                [1, this.$t("editLink")],
            ]);
        }
        setShareType() {
            this.setOption(this.shareType);
            let trackType = this.shareType == 0 ? "viewonly" : "canedit";
            this.$track("share", "Permissionselection", `permissiontype: ${trackType}`);
            if (this.shareType == 1 && !this.internal) {
                this.showShareEditTips();
            }
        }
        get shareTypeString() {
            return this.shareLinkTypeMap.get(this.shareType);
        }
        get shareUseable() {
            return this.$store.state.shareUseable;
        }
        set shareUseable(v) {
            this.$store.commit("setState", {
                type: "shareUseable",
                data: v,
            });
        }
        showShareEditTips() {
            this.showMessage({
                type: 0,
                imgType: 0,
                content: this.$t("shareEditTips"),
                avoid: true,
                avoidTitle: "shareEditTip",
                sponsor: "shareEditSponsor",
                uniqueListenr: true,
                msgClass: "notShowCancle",
            });
        }

        setOption(type) {
            let query = this.shareLink.split("?").pop();
            let uuid = new URLSearchParams(query).get("code");
            let params = {
                option: type,
            };
            let ts = this;
            let url = `${this.urls.apiUrl}/api/user/${this.userInfo.user_id}/max/share/edit/${uuid}`;
            if (this.isPrivate) {
                url = `${this.urls.apiUrl}/api/web/user/${this.userInfo.user_id}/max/share/edit/${uuid}`;
            }
            axios
                .put(url, params, {
                    headers: {
                        Authorization: "Bearer " + this.userInfo.token,
                    },
                    cancelToken: new axios.CancelToken(function executor(c) {
                        ts.shareCancel = c;
                    }),
                })
                .then((response) => {
                    console.log(true);
                });
            this.closeType();
        }
        get iconList() {
            return [
                {
                    id: 0,
                    name: "wechat",
                    lang: "zh",
                },
                {
                    id: 2,
                    name: "qq",
                    lang: "zh",
                },
                {
                    id: 1,
                    name: "sina",
                    lang: "zh",
                },
                {
                    id: 3,
                    name: "qzone",
                    lang: "zh",
                },
                {
                    id: 4,
                    name: "facebook",
                    lang: "en",
                },
                {
                    id: 5,
                    name: "twitter",
                    lang: "en",
                },

                {
                    id: 6,
                    name: "pinterest",
                    lang: "en",
                },
                {
                    id: 8,
                    name: "line",
                    lang: "en",
                },
            ].filter((item) => item.lang == this.buildLang);
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get shareLinkCode() {
            return this.$store.state.shareLinkCode;
        }
        set shareLinkCode(v) {
            this.$store.commit("setState", {
                type: "shareLinkCode",
                data: v,
            });
        }
        setActive(type: string) {
            if (type === "link") {
                this.activeShare = "link";
            } else {
                if (this.shareHTML) {
                    this.activeShare = "html";
                }
            }
        }
        showFrame(pass, type) {
            let triggerName = this.getShareTrigger(pass, type);
            this.$openBuyPage(triggerName);
        }
        switchPrivate(v) {
            if (!this.vip) {
                this.showFrame(!this.hasPass, this.expireType);
                this.hasPass = false;
                return;
            }
            let id = this.$store.state.shareId;
            let updateShareFile = () => {
                this.isLoadingSw = true;
                let params = {
                    exp: Math.round((new Date().getTime() + 100000000000) / 1000),
                    private: v ? 1 : 0,
                };
                let ts: any = this;
                let url = `${this.urls.apiUrl}/api/user/${this.userInfo.user_id}/max/share/${id}`;
                if (this.isPrivate) {
                    url = `${this.urls.apiUrl}/api/web/user/${this.userInfo.user_id}/max/share/${id}`;
                }
                axios
                    .put(url, params, {
                        headers: {
                            Authorization: "Bearer " + this.userInfo.token,
                        },
                        cancelToken: new axios.CancelToken(function executor(c) {
                            ts.shareCancel = c;
                        }),
                    })
                    .then((response) => {
                        clearTimeout(this.shareTimer);
                        if (response.data.data && response.data.data.code) {
                            this.shareLinkCode = response.data.data.code;
                            this.$track("share", "password", "type: addpassword");
                        } else {
                            this.shareLinkCode = null;
                            this.$track("share", "password", "type: deletepassword");
                        }
                        this.isLoadingSw = false;
                    });
            };
            updateShareFile();
        }
        clickIcon(id) {
            let url = "";
            let shareLink = encodeURIComponent(this.shareLink);
            switch (id) {
                case 0:
                    this.toggleType("type4");
                    if (this.showType === "type4") {
                        this.$track("modal", "file", "share to weixin");
                    }
                    break;
                case 1:
                    this.$track("modal", "file", "share to weibo");
                    // this.sensors.track('copyShareLink', {
                    //     Catalogues: 'saveFileProcess',
                    //     file_source: this.$store.state.user.file_source,
                    //     template_type: this.$store.state.user.template_type,
                    //     share_way: 'weibo'
                    // });
                    url = `http://service.weibo.com/share/share.php?url=${shareLink}&type=button&style=number&appkey=3113778129&title=${this.shareData.title}&pic=${this.shareData.imgUrl}&ralateUid=6009693789&language=zh_cn`;
                    this.openLink(url);
                    break;
                case 2:
                    this.$track("modal", "file", "share to qq");
                    // this.sensors.track('copyShareLink', {
                    //     Catalogues: 'saveFileProcess',
                    //     file_source: this.$store.state.user.file_source,
                    //     template_type: this.$store.state.user.template_type,
                    //     share_way: 'qq'
                    // });
                    url = `https://connect.qq.com/widget/shareqq/index.html?url=${shareLink}&title=${this.shareData.title}&desc=&pics=${this.shareData.imgUrl}&summary=Powered by EdrawMax`;
                    this.openLink(url);
                    break;
                case 3:
                    this.$track("modal", "file", "share to qzone");
                    // this.sensors.track('copyShareLink', {
                    //     Catalogues: 'saveFileProcess',
                    //     file_source: this.$store.state.user.file_source,
                    //     template_type: this.$store.state.user.template_type,
                    //     share_way: 'qzone'
                    // });
                    url = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${shareLink}&title=${this.shareData.title}`;
                    this.openLink(url);
                    break;
                case 4:
                    this.$track("modal", "file", "share to facebook");
                    // this.sensors.track('copyShareLink', {
                    //     Catalogues: 'saveFileProcess',
                    //     file_source: this.$store.state.user.file_source,
                    //     template_type: this.$store.state.user.template_type,
                    //     share_way: 'facebook'
                    // });
                    url = `https://www.facebook.com/dialog/feed?app_id=309686709396813&display=page&link=${shareLink}&redirect_uri=https://www.facebook.com`;
                    this.openLink(url);
                    break;
                case 5:
                    this.$track("modal", "file", "share to twitter");
                    // this.sensors.track('copyShareLink', {
                    //     Catalogues: 'saveFileProcess',
                    //     file_source: this.$store.state.user.file_source,
                    //     template_type: this.$store.state.user.template_type,
                    //     share_way: 'twitter'
                    // });
                    url = `https://twitter.com/intent/tweet?url=${shareLink}&text=${this.shareData.title}&via=edrawsoft&hashtags=edraw%2Cdemo`;
                    this.openLink(url);
                    break;
                case 6:
                    this.$track("modal", "file", "share to pinterest");
                    // this.sensors.track('copyShareLink', {
                    //     Catalogues: 'saveFileProcess',
                    //     file_source: this.$store.state.user.file_source,
                    //     template_type: this.$store.state.user.template_type,
                    //     share_way: 'pinterest'
                    // });
                    url = `https://www.pinterest.com/pin/create/button/?guid=&url=${shareLink}&media=${this.shareData.imgUrl}&description=Powered by EdrawMax`;
                    this.openLink(url);
                    break;
                case 7:
                    this.$track("modal", "file", "share to linkedin");
                    // this.sensors.track('copyShareLink', {
                    //     Catalogues: 'saveFileProcess',
                    //     file_source: this.$store.state.user.file_source,
                    //     template_type: this.$store.state.user.template_type,
                    //     share_way: 'linkedin'
                    // });
                    url = `https://www.linkedin.com/shareArticle?mini=true&url=${shareLink}`;
                    this.openLink(url);
                    break;
                case 8:
                    this.toggleType("type4");
                    if (this.showType === "type4") {
                        this.$track("modal", "file", "share to line");
                        // this.sensors.track('copyShareLink', {
                        //     Catalogues: 'saveFileProcess',
                        //     file_source: this.$store.state.user.file_source,
                        //     template_type: this.$store.state.user.template_type,
                        //     share_way: 'line'
                        // });
                    }
                    break;
                default:
                    break;
            }
        }
        toSelLink() {
            (this.$refs.hideLinkInput as any).select();
        }
        openLink(url) {
            // 打开新标签
            if (this.isPC) {
                (<any>window).$qt.jsCallOpenUrl(url);
            } else {
                let newTab = window.open("about:blank");
                newTab.location.href = url;
            }
        }
        create_qrcode(text) {
            qrcode.stringToBytes = qrcode.stringToBytesFuncs["UTF-8"];
            let qr = qrcode(0, "H");
            qr.addData(text, "Byte");
            qr.make();
            return qr.createSvgTag(2, 0);
        }
        createQRCode() {
            if (this.shareLink == "") return;
            this.QRCodeData = "data:image/svg+xml;utf8," + this.create_qrcode(this.shareLink);
        }
        closeModal() {
            this.$store.commit("setState", { type: "shareState", data: false });
        }
        get shareLink() {
            return this.$store.state.shareLink;
        }
        @Watch("shareLink")
        shareLinkChange(val) {
            if (val) {
                this.createQRCode();
            }
        }
        set shareLink(v) {
            this.$store.commit("setState", {
                type: "shareLink",
                data: v,
            });
        }
        get shareHTML() {
            return this.$store.state.shareHTML;
        }
        get shareData() {
            return this.$store.state.shareData;
        }
        changeMemberStype(item, option) {
            let id = this.$store.state.shareId;
            let params: any = {
                share_id: id,
                user_id: item.user_id,
                option,
            };
            if (!item.user_id) {
                params.email = item.email;
                delete params.user_id;
            }
            axios.post(`${this.prefixHttp}${this.userInfo.user_id}/max/share/member`, params, {
                headers: {
                    Authorization: "Bearer " + this.userInfo.token,
                },
            });
            this.memberShowType = -1;
        }
        removeMember(item, index) {
            let id = this.$store.state.shareId;
            let params: any = {
                share_id: id,
                user_id: item.user_id,
            };
            if (!item.user_id) {
                params.email = item.email;
                delete params.user_id;
            }
            axios
                .delete(`${this.prefixHttp}${this.userInfo.user_id}/max/share/member/remove`, {
                    params,
                    headers: {
                        Authorization: "Bearer " + this.userInfo.token,
                    },
                })
                .then(() => {
                    this.shareMembers.splice(index, 1);
                });
            this.memberShowType = -1;
        }
        dateOptions = {
            disabledDate(date) {
                return date && date.valueOf() < new Date(new Date().toLocaleDateString()).getTime();
            },
        };
        get prefixHttp() {
            if (this.isPrivate) {
                return `${this.urls.apiUrl}/api/web/user/`;
            }
            return `${this.urls.apiUrl}/api/user/`;
        }
        updateShareInfo(data) {
            return new Promise((res, rej) => {
                let id = this.$store.state.shareId;
                axios
                    .put(`${this.prefixHttp}${this.userInfo.user_id}/max/share/${id}`, Object.assign({ private: this.hasPass }, data), {
                        headers: {
                            Authorization: "Bearer " + this.userInfo.token,
                        },
                    })
                    .then((response) => {
                        res(response.data.data);
                    })
                    .catch(() => {
                        rej();
                    });
            });
        }
        getFirstName(nick_name: string) {
            return nick_name.trim().split("")[0];
        }
        email = "";
        get emailTest() {
            return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email);
        }
        get expireMap() {
            return new Map([
                [1, this.$t("expire1")],
                [5, this.$t("expire5")],
                [6, this.$t("expire6")],
                [2, this.$t("expire2")],
                [3, this.$t("expire3")],
                [4, this.$t("expire4")],
            ]);
        }
        getShareTrigger(toPass, toType) {
            let expireMap = new Map([
                [1, "Never"],
                [5, "1Day"],
                [6, "3Day"],
                [2, "7Day"],
                [3, "30Day"],
                [4, "Custom"],
            ]);
            let buyTrigger = `share_${toPass ? "Turn" : "Off"}_${expireMap.get(toType)}`;
            return buyTrigger;
        }
        expireType = 1;
        openDatePicker = false;
        expireDate: Date = null;
        closeExpireList(type: number) {
            let triggerName = this.getShareTrigger(this.hasPass, type);
            if ([1, 2, 3, 4].includes(type) && !this.$checkAuth({ type: "others", buyTrigger: triggerName }, "buyframe")) {
                this.getCurrentExpire();
                return;
            }
            // let passTime = Math.round((new Date().getTime() - new Date(new Date().toLocaleDateString()).getTime()) / 1000); // 当天已过去时间
            this.expireType = type;
            this.closeType();
            this.openDatePicker = false;
            let data = {
                end_type: this.expireType,
                end_time: this.expireDate && type == 4 ? this.expireDate.getTime() / 1000 + 86399 : "",
            };
            if (this.expireType !== 4) delete data.end_time;
            this.updateShareInfo(data).then((res: any) => {
                if (this.expireType == 1) {
                    this.expireDate = new Date();
                } else {
                    this.expireDate = new Date(res.end_time * 1000);
                }
                this.$edMessage.success(this.$t("updateSucc"));
            });
        }
        checkExpireListPop(flag) {
            if (flag) {
                this.preventMenuClose = true;
                this.$nextTick(() => {
                    const children = (this.$refs.datePicker as VueComponent)[0]?.$children;
                    const vNode = children && children.find((item) => item.$el.className.indexOf("ivu-date-picker-transfer") != -1);
                    const dom = vNode && vNode.$el;
                    if (dom) {
                        dom.onmouseleave = () => {
                            dom.onmouseleave = null;
                            this.openDatePicker = false;
                        };
                    }
                });
            } else {
                this.$nextTick(() => {
                    this.preventMenuClose = false;
                });
            }
        }
        checkLeaveTarget(e) {
            const children = (this.$refs.datePicker as VueComponent)[0]?.$children;
            const vNode = children && children.find((item) => item.$el.className.indexOf("ivu-date-picker-transfer") != -1);
            const dom = vNode && vNode.$el;
            if (dom && e.toElement && !(e.toElement == dom || dom.contains(e.toElement))) {
                this.openDatePicker = false;
            }
        }
        activeDateString() {
            if (this.expireType == 1) {
                return this.expireMap.get(1);
            } else {
                if (this.lang == "zh") {
                    return this.expireDate.toLocaleString() + this.$t("activeDateSuffix");
                } else {
                    return this.$t("activeDateSuffix") + this.expireDate.toLocaleString();
                }
            }
        }
        get shareExpire() {
            return this.$store.state.shareExpire;
        }
        inviteType = 0;
        clickLoading = false;
        clickEventType(type: string) {
            let share_id = this.$store.state.shareId;
            const map = new Map([
                [
                    "refreshLinkPrev",
                    () => {
                        this.showMessage({
                            sponsor: "shareBox",
                            type: 0,
                            uniqueListenr: true,
                            title: this.$t("refreshWarningTitle"),
                            content: this.$t("refreshWarning"),
                        });
                    },
                ],
                [
                    "inviteMember",
                    async () => {
                        // if(~this.shareMembers.findIndex(item=> [item.email, this.userInfo.email].includes(this.email))){
                        //     this.email = ""
                        //     return
                        // }
                        if (this.clickLoading) return;
                        let data = {
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                            option: this.inviteType,
                            email: this.email,
                            share_id,
                        };
                        try {
                            this.clickLoading = true;
                            await this.$edApi.inviteMember(data);
                            if (!~this.shareMembers.findIndex((item) => [item.email, this.userInfo.email].includes(this.email))) {
                                const item = {
                                    option: this.inviteType,
                                    email: this.email,
                                };
                                const temp_url = URL.createObjectURL(new Blob([JSON.stringify(item)], { type: "text/plain" }));
                                const uuid = temp_url.toString();
                                URL.revokeObjectURL(temp_url);
                                this.shareMembers.push(
                                    Object.assign(
                                        {
                                            uuid,
                                        },
                                        item
                                    )
                                );
                            } else {
                                for (let i = 0; i < this.shareMembers.length; i++) {
                                    let item = this.shareMembers[i];
                                    if (item.email == this.email) {
                                        item.option = this.inviteType;
                                        this.shareMembers.splice(i, 1, item);
                                        break;
                                    }
                                }
                            }
                            this.$edMessage.success(this.$t("sendInviteSucc"));
                            this.clickLoading = false;
                        } catch (error) {
                            this.clickLoading = false;
                        }
                    },
                ],
                [
                    "resetPassword",
                    async () => {
                        try {
                            this.clickLoading = true;
                            const data: any = await this.updateShareInfo({ reset_pwd: 1 });
                            this.shareLinkCode = data.code;
                            this.clickLoading = false;
                        } catch (error) {
                            this.clickLoading = false;
                        }
                    },
                ],
                [
                    "setShareUsable",
                    () => {
                        this.$edApi.setShareUsable({
                            share_id,
                            switch: this.shareUseable,
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                        });
                    },
                ],
            ]);
            map.has(type) && map.get(type)();
        }
        initExpire() {
            if (this.shareExpire.end_type) {
                this.expireType = this.shareExpire.end_type;
            }
            if (this.shareExpire.end_time) {
                this.expireDate = new Date(this.shareExpire.end_time * 1000);
            }
        }
        get shareMembers() {
            return this.$store.state.shareMembers;
        }
        set shareMembers(v) {
            this.$store.commit("setState", {
                type: "shareMembers",
                data: v,
            });
        }
        get isShareEdit() {
            return false;
            // return Boolean(this.$store.state.shareUUID);
        }
        get isPreviewView() {
            return this.$store.state.filePreview;
        }
        getPreviewLimit(value) {
            return this.isPreviewView ? this.shareTypeMap.get(0) : value;
        }
        getShareMembers() {
            return this.$edApi
                .getMembers({
                    id: this.userInfo.user_id,
                    shareId: this.$store.state.shareId,
                    token: this.userInfo.token,
                })
                .then((data) => {
                    this.$store.commit("setState", {
                        type: "shareExpire",
                        data: {
                            end_type: data.end_type,
                            end_time: data.end_time,
                        },
                    });

                    this.shareMembers = data.member.map((item) => {
                        const temp_url = URL.createObjectURL(new Blob([JSON.stringify(item)], { type: "text/plain" }));
                        const uuid = temp_url.toString();
                        URL.revokeObjectURL(temp_url);
                        return {
                            ...item,
                            uuid,
                        };
                    });
                    (<any>this.$refs.dialog).resetPosition();
                });
        }
        previewUrl = "";
        mounted() {
            this.$bus.$on("msgOperation-shareBox", async (data) => {
                if (data.sponsor == "shareBox" && data.data) {
                    const data: any = await this.updateShareInfo({ reset_link: 1 });
                    this.shareLink = data.link;
                    this.$edMessage.success(this.$t("updateSucc"));
                }
            });
            this.$bus.$on("msgOperation-shareEditSponsor", () => {
                if (this.internal) {
                    this.copyText("link");
                }
            });
            if (!this.isShareEdit && !this.isWorkwx) {
                this.getShareMembers().then(() => {
                    this.initExpire();
                });
            }
        }
        beforeDestroy() {
            this.$bus.$off("msgOperation-shareBox");
            this.$bus.$off("msgOperation-shareEditSponsor");
        }
        copyLink() {
            if (this.internal) {
                let store = localStorage;
                let list = JSON.parse(store.getItem("msgAvoidList")) || [];
                if (!list.includes("shareEditTip") && this.shareType == 1) {
                    this.showShareEditTips();
                } else {
                    this.copyText("link");
                }
            } else {
                this.copyText("link");
            }
        }
        copyText(type: string) {
            const map = new Map([
                [
                    "html",
                    () => {
                        return this.shareHTML;
                    },
                ],
                [
                    "link",
                    () => {
                        const track = () => {
                            let trackType = this.shareType == 0 ? "viewonly" : "canedit";
                            let lockType = this.shareLinkCode ? "yes" : "no";
                            this.$track("share", "copy Link", `permissiontype: ${trackType}; password: ${lockType}`);
                            // this.sensors.track('copyShareLink', {
                            //     Catalogues: 'saveFileProcess',
                            //     file_source: this.$store.state.user.file_source,
                            //     template_type: this.$store.state.user.template_type,
                            //     share_way: 'copyShareLink'
                            // });
                        };
                        if (this.hasPass) {
                            const link = `${this.$t("copyPre1")}：${this.shareLink}`;
                            const code = ` ${this.$t("copyPre2")}：${this.shareLinkCode}`;
                            return link + code;
                        }
                        return this.shareLink;
                    },
                ],
            ]);
            if (map.has(type)) {
                let input = document.createElement("input");
                input.value = map.get(type)();
                document.body.appendChild(input);
                input.select();
                const success = document.execCommand("copy");
                document.body.removeChild(input);
                this.$edMessage.success(this.$t(success ? "copySuccess" : "copyfail"));
            }
        }

        getCurrentExpire() {
            let data = {
                end_type: this.expireType,
                end_time: this.expireDate && this.expireType == 4 ? this.expireDate.getTime() / 1000 : "",
            };
            this.updateShareInfo(data).then((res: any) => {
                if (res?.end_time) {
                    this.expireDate = new Date(res.end_time * 1000);
                }
            });
        }

        created() {
            if (!(<any>window).qrcode) {
                addJs(`${appConfig["sourcePath"]}js/3rd/qrcode.min.js`, this.createQRCode);
            } else {
                this.createQRCode();
            }
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "分享",
    "shareLink": "链接分享",
    "shareHTML": "嵌入第三方",
    "shareTip": "将链接分享给他人，收到链接的人可以查看，编辑您的文件",
    "delPass": "删除密码",
    "addPass": "添加密码",
    "passTip": "输入密码才能查看此文件",
    "wxTip": "请使用微信扫一扫",
    "createLink": "创建链接",
    "cancel": "取消",
    "passCode": "密码保护",
    "copySuccess": "复制成功",
    "copyFail": "复制失败",
    "copyLink": "复制链接",
    "copyLinkCode": "复制链接及密码",
    "copyPre1": "链接",
    "copyPre2": "密码",
    "useHTML": "复制下方代码后，在其他站点中使用",
    "view": "查看者",
    "edit": "编辑者",
    "editS": "可编辑分享",
    "shareTo": "分享至",
    "owner": "所有者",
    "viewLink": "所有人可查看",
    "editLink": "所有人可编辑",
    "refreshWarning": "重置链接后，将会生成新的分享链接，当前的分享链接将会失效，并且也将无法通过旧的分享链接分享给好友。",
    "refreshWarningTitle": "您确定要重置邀请链接吗？",
    "expire1": "永久有效",
    "expire2": "7天有效",
    "expire3": "30天有效",
    "expire4": "自定义时间",
    "expire5": "1天有效",
    "expire6": "3天有效",
    "setExpire": "设置期限",
    "scanCode": "扫二维码立即分享",
    "changeCode": "换一换",
    "shareType": "分享方式",
    "joinMembers": "已加入分享的用户",
    "inviteLink": "链接邀请",
    "inviteUser": "邀请用户",
    "remove": "移出",
    "refreshLink": "重置链接",
    "updateSucc": "修改成功",
    "sendInvite": "发送邀请",
    "sendInviteSucc": "邀请发送成功",
    "email": "输入邮箱",
    "shareEditTips": "文件所有者将具有随时编辑文件的权限，当您分享至其他用户编辑时，请确保您并未在编辑文件，否则其他用户将会无法保存编辑内容。",
    "activeDateSuffix": "前有效"
  },
  "en": {
    "title": "Share",
    "shareLink": "Link Share",
    "shareHTML": "HTML Share",
    "shareTip": "Send the link to others, then they can open and edit this file.",
    "delPass": "Delete password",
    "addPass": "Add Password",
    "passTip": "Password is required to open the file.",
    "wxTip": "Please scan the QR with Wechat",
    "createLink": "Create Link",
    "cancel": "Cancel",
    "passCode": "PassCode",
    "copySuccess": "Successfully Copied",
    "copyFail": "Copy Failed",
    "copyLink": "Copy Link",
    "copyLinkCode": "Copy Link & Code",
    "copyPre1": "Link",
    "copyPre2": "PassCode",
    "useHTML": "Use in HTML",
    "view": "Can View",
    "edit": "Can Edit",
    "editS": "edit & share",
    "shareTo": "Share to",
    "owner": "Owner",
    "viewLink": "Anyone with the link Can view",
    "editLink": "Anyone with the link Can Edit",
    "refreshWarning": "After reset, a new link will be generated, and the old link will be invalid.",
    "refreshWarningTitle": "Are you sure to reset the invitation link?",
    "expire1": "Never expire",
    "expire2": "7 days",
    "expire3": "30 days",
    "expire4": "Customize",
    "expire5": "1 day",
    "expire6": "3 days",
    "setExpire": "Time Limited",
    "scanCode": "Scan the QR code to share immediately",
    "changeCode": "Change",
    "shareType": "Share via",
    "joinMembers": "Users who have joined the collaboration",
    "inviteLink": "Invite with a link",
    "inviteUser": "Invite users",
    "remove": "Remove",
    "refreshLink": "Reset link",
    "updateSucc": "Success",
    "sendInvite": "Send Invite",
    "sendInviteSucc": "Invitation sent",
    "email": "Enter an email",
    "shareEditTips": "The file owner can edit the file at any time. Please remind that if the file owner is editing the file, other users can not save the file.",
    "activeDateSuffix": "Valid until"
  },
  "fr": {
    "title": "Partager",
    "shareLink": "Partage de liens",
    "shareHTML": "Partage HTML",
    "shareTip": "Envoyer le lien à d'autres personnes, qui pourront ensuite ouvrir et afficher ce fichier.",
    "delPass": "Supprimer le mot de passe",
    "addPass": "Ajouter Mot de Passe",
    "passTip": "Un mot de passe est requis pour ouvrir le fichier.",
    "wxTip": "Veuillez scanner le QR avec Wechat",
    "createLink": "Créer un lien",
    "cancel": "Annuler",
    "passCode": "Mot de passe",
    "copySuccess": "Copier avec succès",
    "copyFail": "Échec de copie",
    "copyLink": "Copier le lien",
    "copyLinkCode": "Copier le lien et le mot de passe",
    "copyPre1": "Lien",
    "copyPre2": "Mot de passe",
    "useHTML": "Copier le code ci-dessous et utiliser-le sur d'autres sites",
    "view": "Voir seulement",
    "edit": "modifiable",
    "editS": "Partage modifiable",
    "shareTo": "Partager à",
    "owner": "Propriétaire",
    "viewLink": "Toute personne ayant le lien peut le voir.",
    "editLink": "Toute personne ayant le lien peut éditer.",
    "refreshWarning": "Après la réinitialisation, un nouveau lien sera généré, ce qui annulera le précédent.",
    "refreshWarningTitle": "Êtes-vous sûr de vouloir réinitialiser le lien d'invitation ?",
    "expire1": "Ne jamais expirer",
    "expire2": "7 jours",
    "expire3": "30 jours",
    "expire4": "Personnaliser",
    "expire5": "1 jours",
    "expire6": "3 jours",
    "setExpire": "Durée limitée",
    "scanCode": "扫二维码立即分享",
    "changeCode": "Changer",
    "shareType": "Partager via",
    "joinMembers": "Accès direct",
    "inviteLink": "Inviter avec un lien",
    "inviteUser": "Inviter des utilisateurs",
    "remove": "Supprimer",
    "refreshLink": "Réinitialiser le lien",
    "updateSucc": "Réussi",
    "sendInvite": "Envoyer une invitation",
    "sendInviteSucc": "Invitation envoyée",
    "email": "Enter an email",
    "shareEditTips": "Le propriétaire du fichier peut modifier le fichier à tout moment. Veuillez vous assurer que le propriétaire du fichier ne modifie pas le fichier lors du partage avec d'autres. Sinon, les autres utilisateurs ne peuvent pas enregistrer le contenu d'édition."
  },
  "de": {
    "title": "Teilen",
    "shareLink": "Link teilen",
    "shareHTML": "HTML teilen",
    "shareTip": "Senden Sie den Link an andere, dann können sie diese Datei öffnen und anzeigen.",
    "delPass": "Passwort löschen",
    "addPass": "Passwort hinzufügen",
    "passTip": "Zum Öffnen der Datei ist ein Passwort erforderlich.",
    "wxTip": "Bitte scannen Sie den QR mit Wechat",
    "createLink": "Link erstellen",
    "cancel": "Abbrechen",
    "passCode": "Passwort",
    "copySuccess": "Erfolgreich kopiert",
    "copyFail": "Kopieren gescheitert",
    "copyLink": "Link kopieren",
    "copyLinkCode": "Link und Code kopieren",
    "copyPre1": "Link",
    "copyPre2": "Passwort",
    "useHTML": "In HTML einsetzn",
    "view": "Nur lesen",
    "edit": "Bearbeitbar",
    "editS": "Bearbeiten & Teilen",
    "shareTo": "Teilen an",
    "owner": "Besitzer",
    "viewLink": "Jeder mit dem Link kann ansehen.",
    "editLink": "Jeder mit dem Link kann bearbeiten.",
    "refreshWarning": "Nach dem Zurücksetzen wird ein neuer Link generiert und der alte Link ist ungültig.",
    "refreshWarningTitle": "Sind Sie sicher, dass Sie den Einladungslink zurücksetzen möchten?",
    "expire1": "Läuft nie ab",
    "expire2": "7 Tage",
    "expire3": "30 Tage",
    "expire4": "Personalisieren",
    "expire5": "1 Tage",
    "expire6": "3 Tage",
    "setExpire": "Begrenzte Zeit",
    "scanCode": "扫二维码立即分享",
    "changeCode": "Ändern",
    "shareType": "Freigeben über",
    "joinMembers": "Direkter Zugriff",
    "inviteLink": "Mit einem Link einladen",
    "inviteUser": "Benutzer einladen",
    "remove": "Entfernen",
    "refreshLink": "Link zurücksetzen",
    "updateSucc": "Erfolg",
    "sendInvite": "Einladung senden",
    "sendInviteSucc": "Einladung senden",
    "email": "Eine Email-Adresse eingeben",
    "shareEditTips": "Der Dateibesitzer kann die Datei jederzeit bearbeiten. Stellen Sie sicher, dass der Dateibesitzer die Datei nicht bearbeitet, wenn Sie sie für die anderen Mitarbeiter freigeben. Andernfalls können andere Benutzer den Bearbeitungsinhalt nicht speichern."
  },
  "jp": {
    "title": "共有",
    "shareLink": "リンク共有",
    "shareHTML": "HTML共有",
    "shareTip": "他人にリンクを共有すると、リンクを受け取った人は共有したファイルを閲覧できます。",
    "delPass": "パスワードを削除",
    "addPass": "パスワードを追加",
    "passTip": "このファイルを閲覧するにはパスワードを入力してください",
    "wxTip": "WeChatを使用してスキャンしてください",
    "createLink": "リンクを作成",
    "cancel": "キャンセル",
    "passCode": "パスワード",
    "copySuccess": "コピー成功",
    "copyFail": "コピー失敗",
    "copyLink": "リンクをコピー",
    "copyLinkCode": "リンクとパスワードをコピー",
    "copyPre1": "リンク",
    "copyPre2": "パスワード",
    "useHTML": "以下のコードをコピーして、他のサイトで使用します",
    "view": "閲覧のみ",
    "edit": "編集可能",
    "editS": "編集・共有可能",
    "shareTo": "共有",
    "owner": "所有者",
    "viewLink": "リンクを知っているすべてのユーザーが閲覧可能",
    "editLink": "リンクを知っているすべてのユーザーが編集可能",
    "refreshWarning": "リセット後、新しいリンクが生成され、古いリンクは無効になります。",
    "refreshWarningTitle": "您确定要重置邀请链接吗？",
    "expire1": "無期限",
    "expire2": "7日間",
    "expire3": "30日間",
    "expire4": "カスタマイズ",
    "expire5": "1日間",
    "expire6": "3日間",
    "setExpire": "有効期限",
    "scanCode": "扫二维码立即分享",
    "changeCode": "更新",
    "shareType": "共有先",
    "joinMembers": "直接アクセス",
    "inviteLink": "リンクで招待",
    "inviteUser": "メールで招待",
    "remove": "削除",
    "refreshLink": "リンクをリセット",
    "updateSucc": "成功",
    "sendInvite": "招待する",
    "sendInviteSucc": "招待が送信されました",
    "email": "電子メールを入力する",
    "shareEditTips": "ファイルの所有者はいつでもファイルを編集できます。編集のために他のユーザーと共有する場合は、ファイルを編集していないことを確認してください。そうしないと、他のユーザーが編集したコンテンツを保存できなくなります。"
  },
  "es": {
    "title": "Compartir",
    "shareLink": "Compartir enlace",
    "shareHTML": "Compartir HTML",
    "shareTip": "Envíe el enlace a otros, entonces ellos pueden abrir y ver este archivo",
    "delPass": "Borrar la contraseña",
    "addPass": "Agregar contraseña",
    "passTip": "Se requiere una contraseña para abrir el archivo",
    "wxTip": "Por favor, escanee el QR con Wechat",
    "createLink": "Crear un enlace",
    "cancel": "Cancelar",
    "passCode": "Contraseña",
    "copySuccess": "Copiado con éxito",
    "copyFail": "Copia fallida",
    "copyLink": "Copiar enlace",
    "copyLinkCode": "Copiar enlace y código",
    "copyPre1": "Enlace",
    "copyPre2": "Contraseña",
    "useHTML": "Uso en HTML",
    "view": "ver",
    "edit": "Editar ",
    "editS": "Editar y compartir",
    "shareTo": "Compartir a",
    "owner": "Propietario",
    "viewLink": "Cualquiera que tenga el enlace puede verlo.",
    "editLink": "Cualquiera que tenga el enlace puede editarlo.",
    "refreshWarning": "Tras el reinicio, se generará un nuevo enlace y el antiguo no será válido.",
    "refreshWarningTitle": "¿Estás seguro de restablecer el enlace de invitación?",
    "expire1": "No expira",
    "expire2": "7 días",
    "expire3": "30 días",
    "expire4": "Personalizar",
    "expire5": "1 días",
    "expire6": "3 días",
    "setExpire": "Tiempo Limitado",
    "scanCode": "扫二维码立即分享",
    "changeCode": "Cambiar",
    "shareType": "Compartir vía",
    "joinMembers": "Acceso Directo",
    "inviteLink": "Invitar con un enlace",
    "inviteUser": "Invite users",
    "remove": "Remover",
    "refreshLink": "Reestablecer enlace",
    "updateSucc": "Éxito",
    "sendInvite": "Enviar Invitación",
    "sendInviteSucc": "Invitación enviada",
    "email": "Introduce un correo electrónico",
    "shareEditTips": "El propietario del archivo puede editarlo en cualquier momento. Asegúrese de que el propietario del archivo no esté editando el archivo cuando lo comparta con otros. De lo contrario, otros usuarios no podrán guardar el contenido de edición."
  },
  "pt": {
    "title": "Partilhar",
    "shareLink": "Partilha de Ligação",
    "shareHTML": "Partilha HTML",
    "shareTip": "Enviar a ligação a outros, para poderem abrir e visualizar este ficheiro.",
    "delPass": "Eliminar password",
    "addPass": "Adicionar Password",
    "passTip": "É requerida password para abrir o ficheiro.",
    "wxTip": "Por favor, digitalizar o QR com o WeChat",
    "createLink": "Criar Ligação",
    "cancel": "Cancelar",
    "passCode": "Senha",
    "copySuccess": "Copiado com Sucesso",
    "copyFail": "Cópia Falhada",
    "copyLink": "Copiar Ligação",
    "copyLinkCode": "Copiar Ligação & Código",
    "copyPre1": "Ligação",
    "copyPre2": "Senha",
    "useHTML": "Usar em HTML",
    "view": "Ver",
    "edit": "Editar",
    "editS": "editar e compartilhar",
    "shareTo": "compartilhar com",
    "owner": "Proprietário",
    "viewLink": "Qualquer pessoa com o link pode ver.",
    "editLink": "Qualquer pessoa com o link pode editar.",
    "refreshWarning": "Depois de redefinir, um novo link será gerado e o link antigo será inválido.",
    "refreshWarningTitle": "Tem certeza de que deseja redefinir o link do convite?",
    "expire1": "Nunca expira",
    "expire2": "7 dias",
    "expire3": "30 dias",
    "expire4": "Customizar",
    "expire5": "1 dias",
    "expire6": "3 dias",
    "setExpire": "Tempo Limitado",
    "scanCode": "扫二维码立即分享",
    "changeCode": "Mudar",
    "shareType": "Compartilhar via",
    "joinMembers": "Acesso Direto",
    "inviteLink": "Convidar com um link",
    "inviteUser": "Convidar usuários",
    "remove": "Remover",
    "refreshLink": "Redefinir link",
    "updateSucc": "Sucesso",
    "sendInvite": "Enviar Convite",
    "sendInviteSucc": "Convite enviado",
    "email": "Digite um e-mail",
    "shareEditTips": "O proprietário do arquivo pode editar o arquivo a qualquer momento. Por favor, certifique-se de que o proprietário do arquivo não está editando o arquivo quando compartilhar com outros. Caso contrário, os outros usuários não poderão salvar o conteúdo de edição."
  },
  "it": {
    "title": "Condividi",
    "shareLink": "Condividi Collegamento",
    "shareHTML": "Condividi HTML",
    "shareTip": "Invia il collegamento ad altre persone, per consentire loro di aprire e visualizzare il file.",
    "delPass": "Elimina Password",
    "addPass": "Aggiungi Password",
    "passTip": "Sarà richiesta una password per aprire il file.",
    "wxTip": "Bisogna scansionare il codice QR usando Wechat",
    "createLink": "Crea Collegamento",
    "cancel": "Annulla",
    "passCode": "PassCode",
    "copySuccess": "Copia Eseguita con Successo",
    "copyFail": "Copia Fallita",
    "copyLink": "Copia Collegamento",
    "copyLinkCode": "Copia Collegamento e Codice",
    "copyPre1": "Collegamento",
    "copyPre2": "PassCode",
    "useHTML": "Usa HTML",
    "view": "Visualizzare solamente",
    "edit": "Modificabile",
    "editS": "Condivisibile e modificabile",
    "shareTo": "Condividi su",
    "owner": "Proprietario",
    "viewLink": "Chiunque abbia il link può visualizzare.",
    "editLink": "Chiunque abbia il link può modificare.",
    "refreshWarning": "Dopo il ripristino, verrà generato un nuovo link e il vecchio link non sarà valido.",
    "refreshWarningTitle": "Sei sicuro di reimpostare il link di invito?",
    "expire1": "Non scade mai",
    "expire2": "7 giorni",
    "expire3": "30 giorni",
    "expire4": "Personalizza",
    "expire5": "1 giorni",
    "expire6": "3 giorni",
    "setExpire": "Tempo limitato",
    "scanCode": "扫二维码立即分享",
    "changeCode": "Modifica",
    "shareType": "Condivide tramite",
    "joinMembers": "Accesso Diretto",
    "inviteLink": "Invita con un link",
    "inviteUser": "Invita gli utenti",
    "remove": "Rimuove",
    "refreshLink": "Reimposta link",
    "updateSucc": "Successo",
    "sendInvite": "Manda un invito",
    "sendInviteSucc": "Invito spedito",
    "email": "Inserisci un'e-mail",
    "shareEditTips": "Il proprietario del file può modificare il file in qualsiasi momento. Assicurati che il proprietario del file non stia modificando il file quando lo condividi con altri. In caso contrario, gli altri utenti non potranno salvare il contenuto della modifica."
  },
  "tw": {
    "title": "分享",
    "shareLink": "連結分享",
    "shareHTML": "HTML分享",
    "shareTip": "將連結分享給他人，收到連結的人可以查看，編輯您的檔案",
    "delPass": "刪除密碼",
    "addPass": "添加密碼",
    "passTip": "輸入密碼才能查看此檔案",
    "wxTip": "請使用微信掃一掃",
    "createLink": "建立連結",
    "cancel": "取消",
    "passCode": "密碼",
    "copySuccess": "複製成功",
    "copyFail": "複製失敗",
    "copyLink": "複製連結",
    "copyLinkCode": "複製連結及密碼",
    "copyPre1": "連結",
    "copyPre2": "密碼",
    "useHTML": "複製下方代碼後，在其他站點中使用",
    "view": "進查看",
    "edit": "可編輯",
    "editS": "可編輯分享",
    "shareTo": "分享至",
    "owner": "所有者",
    "viewLink": "所有人可查看",
    "editLink": "所有人可编辑",
    "refreshWarning": "重置链接后，将会生成新的分享链接，当前的分享链接将会失效，并且也将无法通过旧的分享链接分享给好友。",
    "refreshWarningTitle": "您确定要重置邀请链接吗？",
    "expire1": "永久有效",
    "expire2": "7天有效",
    "expire3": "30天有效",
    "expire4": "自定义时间",
    "expire5": "1天有效",
    "expire6": "3天有效",
    "setExpire": "设置期限",
    "scanCode": "扫二维码立即分享",
    "changeCode": "换一换",
    "shareType": "分享方式",
    "joinMembers": "已加入分享的用户",
    "inviteLink": "Invite with a link",
    "inviteUser": "Invite users",
    "remove": "移出",
    "refreshLink": "重置链接",
    "updateSucc": "修改成功",
    "sendInvite": "发送邀请",
    "sendInviteSucc": "邀请发送成功",
    "email": "Enter a email",
    "shareEditTips": "檔案所有者可以隨時編輯檔案。 請注意，如果檔案所有者正在編輯檔案，則其他用戶將無法儲存該檔案。"
  },
  "kr": {
    "title": "공유",
    "shareLink": "링크 공유",
    "shareHTML": "HTML 공유",
    "shareTip": "다른 사용자에게 링크를 보내면 해당 사용자가 이 파일을 열고 편집할 수 있습니다.",
    "delPass": "비밀번호 삭제",
    "addPass": "비밀번호 추가",
    "passTip": "이 파일을 볼 수 있도록 비밀번호를 입력하세요",
    "wxTip": "위챗으로 QR 스캔해 주세요.",
    "createLink": "링크 만들기",
    "cancel": "취소",
    "passCode": "비밀번호",
    "copySuccess": "성공적으로 복사됨",
    "copyFail": "복사 실패",
    "copyLink": "링크 복사",
    "copyLinkCode": "링크 & 비밀번호 복사",
    "copyPre1": "링크",
    "copyPre2": "비밀번호",
    "useHTML": "아래쪽 코드를 복사 후 다른 사이트에서 사용",
    "view": "보기만",
    "edit": "편집 가능",
    "editS": "편집 공유 가능",
    "shareTo": "공유 대상",
    "owner": "생성인",
    "viewLink": "링크 있는 모든 사용자 읽기 가능.",
    "editLink": "링크 있는 모든 사용자 수정 가능.",
    "refreshWarning": "재설정 후 새 링크가 생성되며 이전 링크는 무효가 됩니다.",
    "refreshWarningTitle": "초대 링크를 재설정하겠습니까?",
    "expire1": "영구 유효",
    "expire2": "7일",
    "expire3": "30일",
    "expire4": "사용자 지정",
    "expire5": "1일",
    "expire6": "3일",
    "setExpire": "시간 제한",
    "scanCode": "扫二维码立即分享",
    "changeCode": "변경",
    "shareType": "공유 채널",
    "joinMembers": "직접 액세스",
    "inviteLink": "링크 공유",
    "inviteUser": "사용자 요청",
    "remove": "지우기",
    "refreshLink": "링크 다시 설정",
    "updateSucc": "성공",
    "sendInvite": "초대하기",
    "sendInviteSucc": "초대 완료",
    "email": "이메일 입력",
    "shareEditTips": "파일 소유자는 언제든지 파일을 편집할 수 있습니다. 파일 소유자가 파일을 편집하는 경우 다른 사용자가 파일을 저장할 수 없습니다."
  },
  "id": {
    "title": "Bagikan",
    "shareLink": "Berbagi Tautan",
    "shareHTML": "Berbagi HTML",
    "shareTip": "Bagikan tautan ke orang lain, dan mereka dapat melihat atau mengedit file ini.",
    "delPass": "Hapus kata sandi",
    "addPass": "Tambahkan Kata Sandi",
    "passTip": "Untuk membuka file diperlukan kata sandi.",
    "wxTip": "Pindai QR menggunakan WeChat",
    "createLink": "Buat Tautan",
    "cancel": "Batalkan",
    "passCode": "PassCode",
    "copySuccess": "Berhasil disalin",
    "copyFail": "Gagal Menyalin",
    "copyLink": "Salin Tautan",
    "copyLinkCode": "Salin Tautan & Kode",
    "copyPre1": "Tautan",
    "copyPre2": "PassCode",
    "useHTML": "Gunakan di HTML",
    "view": "Dapat Melihat",
    "edit": "Dapat Mengedit",
    "editS": "edit & bagikan",
    "shareTo": "Bagikan ke",
    "owner": "Pemilik",
    "viewLink": "Siapa pun dengan tautan Dapat melihat",
    "editLink": "Siapa pun dengan tautan Dapat Mengedit",
    "refreshWarning": "Setelah direset, tautan baru akan dibuat, dan tautan lama tidak akan valid.",
    "refreshWarningTitle": "Yakin ingin mereset tautan undangan?",
    "expire1": "Tidak pernah kedaluwarsa",
    "expire2": "7 hari",
    "expire3": "30 hari",
    "expire4": "Kustomisasi",
    "setExpire": "Batas Waktu",
    "scanCode": "Pindai kode QR untuk segera berbagi",
    "changeCode": "Ubah",
    "shareType": "Bagikan lewat",
    "joinMembers": "Pengguna yang telah bergabung dengan kolaborasi",
    "inviteLink": "Undang dengan tautan",
    "inviteUser": "Undang pengguna",
    "remove": "Hapus",
    "refreshLink": "Reset tautan",
    "updateSucc": "Berhasil",
    "sendInvite": "Kirim Undangan",
    "sendInviteSucc": "Undangan terkirim",
    "email": "Masukkan email",
    "shareEditTips": "Pemilik file dapat mengedit file kapan saja. Perlu diingat bahwa jika pemilik file mengedit file, pengguna lain tidak dapat menyimpan file.",
    "activeDateSuffix": "Berlaku hingga"
  }
}
</i18n>
